// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Order history
 */

.OrderHistory_wrap__8ZPac {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  width: 100%;
}

.OrderHistory_title__ywh0O {
  margin: 0;
  font-size: 1.0625rem;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: -0.008em;
  color: var(--text-primary);
}

.OrderHistory_list__pisn2 {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: var(--space-3);
}

/* Card */
.OrderHistory_card__YpM3a {
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--bg);
  transition:
    border-color var(--dur-fast) var(--ease-standard),
    box-shadow var(--dur-fast) var(--ease-standard);
}

.OrderHistory_card__YpM3a:focus-within {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(157, 31, 95, 0.12);
}

/* Clickable header */
.OrderHistory_headerBtn__0Bv2I {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  width: 100%;
  padding: var(--space-4);
  border: 0;
  background: var(--bg);
  font-family: var(--font);
  text-align: left;
  cursor: pointer;
  transition: background-color var(--dur-fast) var(--ease-standard);
}

.OrderHistory_headerBtn__0Bv2I:hover {
  background: var(--bg-tertiary);
}

.OrderHistory_headerBtnOpen__1\\+Lx5 {
  background: var(--bg-secondary);
}

.OrderHistory_headerBtn__0Bv2I:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: -2px;
}

.OrderHistory_headerLeft__OFLsh {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-width: 0;
}

.OrderHistory_pkgIcon__kT0cn {
  flex: none;
  color: var(--primary);
}

.OrderHistory_headerText__Hqa3p {
  display: grid;
  gap: 2px;
  min-width: 0;
}

.OrderHistory_orderLabel__OpOWe {
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 700;
  line-height: 1.45;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.OrderHistory_meta__MrItY {
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.OrderHistory_badge__84QPN {
  display: inline-block;
  margin-left: var(--space-2);
  padding: 2px 7px;
  border-radius: var(--radius-xs);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.OrderHistory_chev__mk3CH {
  flex: none;
  color: var(--text-secondary);
}

/* Details panel */
.OrderHistory_details__tf8fg {
  padding: var(--space-4);
  border-top: 1px solid var(--border-light);
  background: var(--bg-tertiary);
}

.OrderHistory_details__tf8fg p {
  margin: 0 0 var(--space-2);
  font-size: 0.875rem;
  line-height: 1.55;
  color: var(--text-primary);
}

.OrderHistory_details__tf8fg p:last-child {
  margin-bottom: 0;
}

/* Line items */
.OrderHistory_itemsSection__atT13 {
  margin-top: var(--space-4);
  padding-top: var(--space-4);
  border-top: 1px solid var(--border);
}

.OrderHistory_itemsTitle__zVQLU {
  margin: 0 0 var(--space-2);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.OrderHistory_itemList__hmUVS {
  list-style: none;
  margin: 0;
  padding: 0;
}

.OrderHistory_itemRow__AnmGw {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-3) 0;
}

.OrderHistory_itemRow__AnmGw + .OrderHistory_itemRow__AnmGw {
  border-top: 1px solid var(--border-light);
}

.OrderHistory_itemInfo__LNPMi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.OrderHistory_itemName__nvkBu {
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.45;
  color: var(--text-primary);
}

.OrderHistory_itemVariant__nqnLK {
  font-size: 0.8125rem;
  line-height: 1.5;
  color: var(--text-secondary);
}

.OrderHistory_itemMeta__BFM7A {
  display: flex;
  align-items: baseline;
  gap: var(--space-4);
  flex: none;
  white-space: nowrap;
}

.OrderHistory_itemQty__NUQWT {
  font-size: 0.8125rem;
  color: var(--text-secondary);
}

.OrderHistory_itemPrice__2AVoe {
  font-size: 0.9375rem;
  font-weight: 700;
  color: var(--text-primary);
}

/* Flat states */
.OrderHistory_loading__rPAMU,
.OrderHistory_empty__lKwm1,
.OrderHistory_error__uJw-c {
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.55;
  color: var(--text-secondary);
}

.OrderHistory_error__uJw-c {
  color: var(--error);
  font-weight: 600;
}

.OrderHistory_link__FVYI5 {
  color: var(--link);
  font-weight: 600;
  text-decoration: underline;
}

.OrderHistory_link__FVYI5:hover {
  color: var(--primary);
}

@media (max-width: 600px) {
  .OrderHistory_headerBtn__0Bv2I {
    padding: var(--space-3);
  }

  .OrderHistory_details__tf8fg {
    padding: var(--space-3);
  }

  .OrderHistory_itemRow__AnmGw {
    flex-direction: column;
    gap: var(--space-1);
  }

  .OrderHistory_itemMeta__BFM7A {
    gap: var(--space-3);
  }
}

@media (prefers-reduced-motion: reduce) {
  .OrderHistory_card__YpM3a,
  .OrderHistory_headerBtn__0Bv2I {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DashBoard/OrderHistory.module.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;EACrB;;mDAEiD;AACnD;;AAEA;EACE,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,iEAAiE;AACnE;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;;;EAGE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":["/*\n * Order history\n */\n\n.wrap {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n  width: 100%;\n}\n\n.title {\n  margin: 0;\n  font-size: 1.0625rem;\n  font-weight: 700;\n  line-height: 1.4;\n  letter-spacing: -0.008em;\n  color: var(--text-primary);\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: var(--space-3);\n}\n\n/* Card */\n.card {\n  overflow: hidden;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--bg);\n  transition:\n    border-color var(--dur-fast) var(--ease-standard),\n    box-shadow var(--dur-fast) var(--ease-standard);\n}\n\n.card:focus-within {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(157, 31, 95, 0.12);\n}\n\n/* Clickable header */\n.headerBtn {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-3);\n  width: 100%;\n  padding: var(--space-4);\n  border: 0;\n  background: var(--bg);\n  font-family: var(--font);\n  text-align: left;\n  cursor: pointer;\n  transition: background-color var(--dur-fast) var(--ease-standard);\n}\n\n.headerBtn:hover {\n  background: var(--bg-tertiary);\n}\n\n.headerBtnOpen {\n  background: var(--bg-secondary);\n}\n\n.headerBtn:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: -2px;\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  min-width: 0;\n}\n\n.pkgIcon {\n  flex: none;\n  color: var(--primary);\n}\n\n.headerText {\n  display: grid;\n  gap: 2px;\n  min-width: 0;\n}\n\n.orderLabel {\n  margin: 0;\n  font-size: 0.9375rem;\n  font-weight: 700;\n  line-height: 1.45;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.meta {\n  margin: 0;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.badge {\n  display: inline-block;\n  margin-left: var(--space-2);\n  padding: 2px 7px;\n  border-radius: var(--radius-xs);\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.chev {\n  flex: none;\n  color: var(--text-secondary);\n}\n\n/* Details panel */\n.details {\n  padding: var(--space-4);\n  border-top: 1px solid var(--border-light);\n  background: var(--bg-tertiary);\n}\n\n.details p {\n  margin: 0 0 var(--space-2);\n  font-size: 0.875rem;\n  line-height: 1.55;\n  color: var(--text-primary);\n}\n\n.details p:last-child {\n  margin-bottom: 0;\n}\n\n/* Line items */\n.itemsSection {\n  margin-top: var(--space-4);\n  padding-top: var(--space-4);\n  border-top: 1px solid var(--border);\n}\n\n.itemsTitle {\n  margin: 0 0 var(--space-2);\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n}\n\n.itemList {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.itemRow {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding: var(--space-3) 0;\n}\n\n.itemRow + .itemRow {\n  border-top: 1px solid var(--border-light);\n}\n\n.itemInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.itemName {\n  font-size: 0.9375rem;\n  font-weight: 600;\n  line-height: 1.45;\n  color: var(--text-primary);\n}\n\n.itemVariant {\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.itemMeta {\n  display: flex;\n  align-items: baseline;\n  gap: var(--space-4);\n  flex: none;\n  white-space: nowrap;\n}\n\n.itemQty {\n  font-size: 0.8125rem;\n  color: var(--text-secondary);\n}\n\n.itemPrice {\n  font-size: 0.9375rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n/* Flat states */\n.loading,\n.empty,\n.error {\n  margin: 0;\n  font-size: 0.9375rem;\n  line-height: 1.55;\n  color: var(--text-secondary);\n}\n\n.error {\n  color: var(--error);\n  font-weight: 600;\n}\n\n.link {\n  color: var(--link);\n  font-weight: 600;\n  text-decoration: underline;\n}\n\n.link:hover {\n  color: var(--primary);\n}\n\n@media (max-width: 600px) {\n  .headerBtn {\n    padding: var(--space-3);\n  }\n\n  .details {\n    padding: var(--space-3);\n  }\n\n  .itemRow {\n    flex-direction: column;\n    gap: var(--space-1);\n  }\n\n  .itemMeta {\n    gap: var(--space-3);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .card,\n  .headerBtn {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `OrderHistory_wrap__8ZPac`,
	"title": `OrderHistory_title__ywh0O`,
	"list": `OrderHistory_list__pisn2`,
	"card": `OrderHistory_card__YpM3a`,
	"headerBtn": `OrderHistory_headerBtn__0Bv2I`,
	"headerBtnOpen": `OrderHistory_headerBtnOpen__1+Lx5`,
	"headerLeft": `OrderHistory_headerLeft__OFLsh`,
	"pkgIcon": `OrderHistory_pkgIcon__kT0cn`,
	"headerText": `OrderHistory_headerText__Hqa3p`,
	"orderLabel": `OrderHistory_orderLabel__OpOWe`,
	"meta": `OrderHistory_meta__MrItY`,
	"badge": `OrderHistory_badge__84QPN`,
	"chev": `OrderHistory_chev__mk3CH`,
	"details": `OrderHistory_details__tf8fg`,
	"itemsSection": `OrderHistory_itemsSection__atT13`,
	"itemsTitle": `OrderHistory_itemsTitle__zVQLU`,
	"itemList": `OrderHistory_itemList__hmUVS`,
	"itemRow": `OrderHistory_itemRow__AnmGw`,
	"itemInfo": `OrderHistory_itemInfo__LNPMi`,
	"itemName": `OrderHistory_itemName__nvkBu`,
	"itemVariant": `OrderHistory_itemVariant__nqnLK`,
	"itemMeta": `OrderHistory_itemMeta__BFM7A`,
	"itemQty": `OrderHistory_itemQty__NUQWT`,
	"itemPrice": `OrderHistory_itemPrice__2AVoe`,
	"loading": `OrderHistory_loading__rPAMU`,
	"empty": `OrderHistory_empty__lKwm1`,
	"error": `OrderHistory_error__uJw-c`,
	"link": `OrderHistory_link__FVYI5`
};
export default ___CSS_LOADER_EXPORT___;
